import { render, staticRenderFns } from "./confirmPage.vue?vue&type=template&id=d5a13770&scoped=true"
import script from "./confirmPage.vue?vue&type=script&lang=js"
export * from "./confirmPage.vue?vue&type=script&lang=js"
import style0 from "./confirmPage.vue?vue&type=style&index=0&id=d5a13770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5a13770",
  null
  
)

export default component.exports